module.exports = __webpack_public_path__ + "img/EACalculateItem6.20167d8b.svg";